import styled from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';

const modifiers = {
  small: () => ({
    styles: `
      padding: .625rem;

      & > div {
        font-size: .75rem;
        line-height: 1.25rem;
      }
    `,
  }),
};

export const ErrorNoticeStyled = styled.div.attrs({
  className: 'ErrorNotice',
})`
  background-color: ${({ theme, level }) => theme.status[level].lighter};
  border: 1px solid ${({ theme, level }) => theme.status[level].main};
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 1.25rem;
  color: ${({ theme, level }) => theme.status[level].main};
  font-size: 0.9375rem;
  font-weight: 500;
  margin-top: 1rem;
  width: 100%;

  svg {
    cursor: pointer;
    width: 0.75rem;

    path {
      fill: gray;
    }
  }

  ${applyStyleModifiers(modifiers)}
`;

export const ErrorNoticeContent = styled.div`
  line-height: 1.5;
  margin-right: 1.25rem;

  a:link, a:visited {
    color: inherit;
    text-decoration: underline;
  }
`;
